import React from "react";
import { Route } from "react-router-dom";
import Maps from "../routes/Maps/Maps";
import Data from "../routes/Data/Data";
import Cases from "../routes/Cases/Cases";
import Analysis from "../routes/Analysis/Analysis";
import Results from "../routes/Results/Results";
import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  toolbar: {
    paddingRight: 24,
  },
  // appBarSpacer: theme.mixins.toolbar,
  appBarSpacer: {},
  content: {
    flexGrow: 1,
    height: "100vh",
    paddingLeft: `${drawerWidth}px`,
  },
  contentShift: {
    paddingLeft: "70px",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(10),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

export const ContentWrapper = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Route
        path="/dashboard/maps"
        render={(props) => <Maps classes={classes} {...props}></Maps>}
      ></Route>
      <Route
        path="/dashboard/data"
        render={(props) => <Data classes={classes} {...props}></Data>}
      ></Route>
      <Route
        path="/dashboard/cases"
        render={(props) => <Cases classes={classes} {...props}></Cases>}
      ></Route>
      <Route
        path="/dashboard/analysis"
        render={(props) => <Analysis classes={classes} {...props}></Analysis>}
      ></Route>
      <Route
        path="/dashboard/results"
        render={(props) => <Results classes={classes} {...props}></Results>}
      ></Route>
    </React.Fragment>
  );
};

export default ContentWrapper;
